<template>
    <div id="myinfo-register-email">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="singpassEmail"
          name          ="singpassEmail"
          type          ="email"
          class         =""
          placeholder   =""
          @input        ="onInput($event)"
          :label        ="$t('general-text-email')"
          :value        ="email"
          autocomplete  ="off"
          outline
          floating-label
          clear-button
          required
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'email'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setEmail',
      ]),

      async onInput(e){
        await this.setEmail(e.target.value);
        await this.validateInput(e.target);
        this.validateNextButton()
      },

      async validateInput(e){
        this.$emit("validateInput", e);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>